import { All, KeyValue, Query } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import MarketShareSearchForm from "../components/SOD/MarketShare/MarketShareSearchForm";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateFilter: (filterField: string, value: string | number) => {
      dispatch(actions.updateFilter(filterField, value));
    },
    updateUi: (uiField: string, value: string | KeyValue[]) => {
      dispatch(actions.updateUi(uiField, value));
    },
    resetState: (state: Query) => {
      dispatch(actions.resetState(state));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MarketShareSearchForm);
